import { createSlice } from "@reduxjs/toolkit";
import { IExceptKeyword, IMonitor, IMonitorClick, IMonitorIP, IMonitorUser } from "api/types/_monitor";
import { PaginationResponse, ResponseData } from "api/types/_public";
import { getExceptKeywords, getMonitorClicks, getMonitors, getMonitorUsers, getMonitorIP, getMonitorClickSettings } from "./thunk";


export interface IState {
  monitors: ResponseData<IMonitor[]> & PaginationResponse | null,
  isMonitorLoading: boolean,
  isMonitorSuccess: boolean,

  monitorUsers: ResponseData<IMonitorUser[]> & PaginationResponse | null,
  isMonitorUserLoading: boolean,
  isMonitorUserSuccess: boolean,

  monitorClicks: ResponseData<IMonitorClick[]> & PaginationResponse | null,
  isMonitorClickLoading: boolean,
  isMonitorClickSuccess: boolean,

  monitorClickSettings: ResponseData<IMonitorClick[]> & PaginationResponse | null,
  isMonitorClickSettingLoading: boolean,
  isMonitorClickSettingSuccess: boolean,

  exceptKeywords: ResponseData<IExceptKeyword[]> | null,
  isExceptKeywordLoading: boolean,
  isExceptKeywordSuccess: boolean,

  monitorIP: ResponseData<IMonitorIP[]> | null,
  isMonitorIPLoading: boolean,
  isMonitorIPSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  monitors: null,
  isMonitorLoading: false,
  isMonitorSuccess: false,

  monitorUsers: null,
  isMonitorUserLoading: false,
  isMonitorUserSuccess: false,

  monitorClicks: null,
  isMonitorClickLoading: false,
  isMonitorClickSuccess: false,

  monitorClickSettings: null,
  isMonitorClickSettingLoading: false,
  isMonitorClickSettingSuccess: false,

  exceptKeywords: null,
  isExceptKeywordLoading: false,
  isExceptKeywordSuccess: false,

  monitorIP: null,
  isMonitorIPLoading: false,
  isMonitorIPSuccess: false,

  error: {},
};

const MonitorSlice = createSlice({
  name: "Monitor",
  initialState,
  reducers: {
    changeStatusAlarmAction(state: any, action: any) {
      state.monitors = action.payload;
    },
  },
  extraReducers: (builder) => {
    //get monitors
    builder.addCase(getMonitors.pending, (state: IState, action: any) => {
      state.isMonitorLoading = true
    });
    builder.addCase(getMonitors.fulfilled, (state: IState, action: any) => {
      state.monitors = action.payload.data;
      state.isMonitorSuccess = true;
      state.isMonitorLoading = false;
    });
    builder.addCase(getMonitors.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isMonitorSuccess = false;
      state.isMonitorLoading = false;
    });

    //get monitor Users
    builder.addCase(getMonitorUsers.pending, (state: IState, action: any) => {
      state.isMonitorUserLoading = true
    });
    builder.addCase(getMonitorUsers.fulfilled, (state: IState, action: any) => {
      state.monitorUsers = action.payload.data;
      state.isMonitorUserSuccess = true;
      state.isMonitorUserLoading = false;
    });
    builder.addCase(getMonitorUsers.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isMonitorUserSuccess = false;
      state.isMonitorUserLoading = false;
    });


    //get monitor Clicks
    builder.addCase(getMonitorClicks.pending, (state: IState, action: any) => {
      state.isMonitorClickLoading = true
    });
    builder.addCase(getMonitorClicks.fulfilled, (state: IState, action: any) => {
      state.monitorClicks = action.payload.data;
      state.isMonitorClickSuccess = true;
      state.isMonitorClickLoading = false;
    });
    builder.addCase(getMonitorClicks.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isMonitorClickSuccess = false;
      state.isMonitorClickLoading = false;
    });


    //get monitor Click Settings
    builder.addCase(getMonitorClickSettings.pending, (state: IState, action: any) => {
      state.isMonitorClickSettingLoading = true
    });
    builder.addCase(getMonitorClickSettings.fulfilled, (state: IState, action: any) => {
      state.monitorClickSettings = action.payload.data;
      state.isMonitorClickSettingSuccess = true;
      state.isMonitorClickSettingLoading = false;
    });
    builder.addCase(getMonitorClickSettings.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isMonitorClickSettingSuccess = false;
      state.isMonitorClickSettingLoading = false;
    });

    //get monitor Except Keywords
    builder.addCase(getExceptKeywords.pending, (state: IState, action: any) => {
      state.isExceptKeywordLoading = true
    });
    builder.addCase(getExceptKeywords.fulfilled, (state: IState, action: any) => {
      state.exceptKeywords = action.payload.data;
      state.isExceptKeywordSuccess = true;
      state.isExceptKeywordLoading = false;
    });
    builder.addCase(getExceptKeywords.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isExceptKeywordSuccess = false;
      state.isExceptKeywordLoading = false;
    });

    // get monitor IP
    builder.addCase(getMonitorIP.pending, (state: IState, action: any) => {
      state.isMonitorIPLoading = true
    });
    builder.addCase(getMonitorIP.fulfilled, (state: IState, action: any) => {
      state.monitorIP = action.payload.data;
      state.isMonitorIPSuccess = true;
      state.isMonitorIPLoading = false;
    });
    builder.addCase(getMonitorIP.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isMonitorIPSuccess = false;
      state.isMonitorIPLoading = false;
    });
  },
});

export const {
  changeStatusAlarmAction
} = MonitorSlice.actions;

export default MonitorSlice.reducer;
